<template>
    <div class="Page3-Ponds-message">
        <div class="Page3-Ponds-message-container" :style="{ height: messageContainerHeight + 'px' }">
            <div
                class="message2"
                v-for="(content, index) in messagesContents"
                :key="index"
                style="height: 50px;"
            >
            <span class="dot" :style="{ backgroundColor: getRandomColor() }"></span>
            <span class="label">{{messagesLables[index]}}</span>
            <span class="content">{{ content }}</span>
            <span class="unit">{{messageUnits[index]}}</span>
            </div>
        </div>
  </div>
</template>

<script>
export default {
  name: 'EquipMessage',
  props: {
    pondsid: Number,
  },
  data() {
    return {
      messageContainerHeight: 2,
      messageHeight: 30,
      messagesContents: [

      ],
      messagesLables:[
        '描述:  ',
        '面积:  ',
        '养殖种类:  ',
        '入池时间: ',
        '平均体长: ',
        '平均体重: ',
      ],
      messageUnits:[
        '',
        '㎡',
        '',
        '',
        'cm',
        'g',
      ]
    }
  },
  computed: {
    messageContainerHei() {
      // 假设容器最多显示5条消息
      return this.messages.length * 40 + 100;
    },
  },
  methods: {
    getRandomColor() {
      let letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    getmessage() {
      this.request.get("/api/ponds/getmessage", {
        params: {
          pondsid: this.pondsid
        }
      }).then(res => {
            let data = res.data;
            this.messagesContents = [
              data.name,
              data.acer.toString(),
              data.fishVar,
              data.entryDate,
              data.lenth.toString(),
              data.weight.toString(),
            ]
        }
        )
    }
  },
  watch: {
    pondsid() {
      this.getmessage()
    }
  },
  mounted() {
    this.getmessage()
  },
}
</script>

<style lang="less">
.Page3-Ponds-message {
  height: 100%;
  width: 300px; /* 你可以根据需要调整宽度 */
  overflow: hidden;
  position: relative;
  border: 0px solid #977575;
}

.Page3-Ponds-message-container {
  margin: 45px  30px;
  width: 300px; /* 你可以根据需要调整宽度 */
  height: 100%;
  position: relative;
}

.message2 {
  color: #fff;
  padding: 25px;
    font-size: 20px;
  border-bottom: 0px
}
.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #75deef;
  display: inline-block;
  margin-right: 5px;
}
</style>